<script setup lang="ts" generic="TValue extends AcceptableValue">
import type { AcceptableValue, SelectRootEmits, SelectRootProps } from "reka-ui"
import { SelectRoot, useForwardPropsEmits } from "reka-ui"

const props = defineProps<SelectRootProps<TValue>>()
const emits = defineEmits<SelectRootEmits<TValue>>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <SelectRoot v-bind="forwarded">
    <slot />
  </SelectRoot>
</template>
